import { Checkbox, CheckboxProps } from "@mui/material";
import React from "react";

const CheckboxWrapper: React.FC<CheckboxProps> = ({ ...props }) => (
 
  <Checkbox {...props} />
);

export default CheckboxWrapper;